export default __webpack_public_path__ + "static/media/MU.2b6eab73.svg";